module.exports = __webpack_public_path__ + "static/media/DSC08918.acb22807.jpg";